// extracted by mini-css-extract-plugin
export var clamp = "BetCardHeader-module--clamp--86394";
export var deactivated = "BetCardHeader-module--deactivated--edd41";
export var header = "BetCardHeader-module--header--34c47";
export var iconSlot = "BetCardHeader-module--iconSlot--7f0c7";
export var subtitle = "BetCardHeader-module--subtitle--8aa3c";
export var text = "BetCardHeader-module--text--72074";
export var title = "BetCardHeader-module--title--3babe";